import React, { useEffect, useRef } from 'react';
import { Tag } from '@lux/grid';
import { StyledGridStandaloneCol } from './styles';
const CarouselItemsContainer = (props) => {
    const { children, visibleItems, visibleItemsXs, visibleItemsSm, visibleItemsMd, visibleItemsLg, onRef, onTabNavigation, initialScroll, shiftLeftFirstItem = false, ...rest } = props;
    const carouselItemProps = {
        span: (12 / visibleItems),
        ...(visibleItemsXs && { spanXs: (12 / visibleItemsXs) }),
        ...(visibleItemsSm && { spanSm: (12 / visibleItemsSm) }),
        ...(visibleItemsMd && { spanMd: (12 / visibleItemsMd) }),
        ...(visibleItemsLg && { spanLg: (12 / visibleItemsLg) }),
    };
    const handleKeyUp = (e) => {
        e.preventDefault();
        if (e.key === 'Tab' && onTabNavigation) {
            onTabNavigation(e);
        }
    };
    const selfRef = useRef(null);
    const carouselRef = onRef || selfRef;
    useEffect(() => {
        if (carouselRef && carouselRef.current && initialScroll) {
            const { childNodes, childElementCount } = carouselRef.current;
            if (childElementCount >= initialScroll) {
                const { offsetLeft, offsetWidth } = childNodes[Math.floor(initialScroll)];
                carouselRef.current.scrollLeft = offsetLeft + offsetWidth * (initialScroll % 1);
            }
        }
    }, [carouselRef, initialScroll]);
    return (React.createElement("ul", Object.assign({ ref: carouselRef, onKeyUp: handleKeyUp }, rest, { role: "presentation" }), React.Children.map(children, (child, index) => (React.createElement(StyledGridStandaloneCol, Object.assign({ tag: Tag.LI, shiftLeft: shiftLeftFirstItem ? index === 0 : false }, carouselItemProps), child)))));
};
export default CarouselItemsContainer;
//# sourceMappingURL=component.js.map